<template>
	<v-card class="app-favorite-group-form py-4 px-6 ml-1 mt-n1">
		<ao-text-field
			v-model="form.name.model"
			hide-details
			clearable
			persistent-clear
			class="pa-2"
			:label="$t('Group name')"
			variant="underlined"
			color="primary"
			clear-icon="mdi-close"
			:loading="form.name.$loading"
			:disabled="form.name.$loading"
			:error="!form.name.$valid && form.name.$touched"
			:error-messages="[
				...(form.name.$errors?.required && form.name.$touched
					? [$t('This field is required')]
					: []),
				...(form.name.$errors?.maxLength && form.name.$touched
					? ['Length must me less than 256']
					: []),
			]"
			@blur="form.name.onFieldBlur"
		/>
		<div class="">
			<ao-btn
				color="primary"
				variant="flat"
				@click="onSaveGroup"
			>
				{{ $t('Create group') }}
			</ao-btn>
			<ao-btn
				variant="plain"
				@click="$emit('cancel')"
			>
				{{ $t('Cancel') }}
			</ao-btn>
		</div>
	</v-card>
</template>

<script setup>
import FormManager from '@/services/formManager/formManagerService'
import { required, maxLength } from '@/services/formManager/formValidators'

const props = defineProps({
	currentState: {
		type: Object,
	},
})

const emit = defineEmits({
	saveGroup: null,
	cancel: null,
})

const form = FormManager({
	fields: {
		name: {
			validators: {
				required: (value) => required(value),
				maxLength: (value) => maxLength(value, 256),
			},
			defaultValue: () => props.currentState?.name || '',
		},
	},
})

const onSaveGroup = () => {
	if (form.validateForm()) {
		emit('saveGroup', {
			name: form.name.model,
		})
	}
}
</script>
